import { Profile, ProfileCustomValue } from "PFCore/types";

import { SkillsExplorer } from "../../../charts/skills_explorer";
import { SkillsViewCommonProps } from "../../skills_section.types";
import { SkillsEmptyState } from "../skills_empty_state";

type SkillsChartViewProps = {
  profile: Profile;
  skills: ProfileCustomValue[];
} & SkillsViewCommonProps;

export const SkillsChartView = ({ skills, searchTerm, setSearchTerm, ...props }: SkillsChartViewProps) =>
  skills.length ? (
    <SkillsExplorer skills={skills} {...props} />
  ) : (
    <SkillsEmptyState searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
  );
